'use strict'
const merge = require('webpack-merge')

module.exports = merge({
  API_URL: '/apis',
  APIP_URL: '/apip',
  APIW_URL: '/apiw',
  APIH_URL: '/apih',
  APIT_URL: '/apit',
  PATH_URL: 'http://172.16.0.1:8080/',
})

